/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_InterviewInputs */

const en_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const de_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch`)
};

const fr_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretien`)
};

const es_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrevista`)
};

const it_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloquio`)
};

const nl_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegesprek`)
};

const pl_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowa kwalifikacyjna`)
};

const fi_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työhaastattelu`)
};

const da_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsamtale`)
};

const sv_applications_status_interview = /** @type {(inputs: Applications_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbintervju`)
};

/**
* | output |
* | --- |
* | "Interview" |
*
* @param {Applications_Status_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_interview = /** @type {((inputs?: Applications_Status_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_interview(inputs)
	if (locale === "fr") return fr_applications_status_interview(inputs)
	if (locale === "es") return es_applications_status_interview(inputs)
	if (locale === "it") return it_applications_status_interview(inputs)
	if (locale === "nl") return nl_applications_status_interview(inputs)
	if (locale === "pl") return pl_applications_status_interview(inputs)
	if (locale === "fi") return fi_applications_status_interview(inputs)
	if (locale === "da") return da_applications_status_interview(inputs)
	if (locale === "sv") return sv_applications_status_interview(inputs)
	return en_applications_status_interview(inputs)
});